import { Layer as APILayer } from '@datum-group/isogd-openapi/lib';
import { DatumLayer } from '@datum-map';
import image from '@assets/images/vector.png';
import * as style from './StyleTypes';

// todo добавить в NativeLayer/ObjectCollection информацию о иконке и размере слоя и отказаться от LegendItem
export class LegendItem {
  readonly name: string;
  readonly description?: string;
  readonly styles?: style.LayerStyle;

  constructor(
    readonly apiLayer: APILayer,
    readonly datumLayer: DatumLayer,
    readonly size?: number,
    readonly icon = apiLayer.icon || image,
  ) {
    this.name = apiLayer.layer_name;
    this.description = apiLayer.description;

    // @ts-ignore todo исправить swagger-схему - apiLayer.style
    this.styles = apiLayer.style || undefined;
  }
}
